let appID = $v('pFlowId'); //APP ID
let pageID = $v('pFlowStepId'); //APP_PAGE_ID
let sessionID = $v('pInstance'); // SESSION

function f_errorhandling(errmsg) {

    var obj = JSON.parse(errmsg);

    if (obj.error == apex.lang.getMessage('APEX.SESSION.ALERT.EXPIRED')) {
        apex.page.cancelWarnOnUnsavedChanges();

        switch('&ENVIRONMENT.') {
            case 'DEV':
                window.location.replace('https://dev.rail-flow.com/ords/r/sd/rq/login_desktop');
                break;
            case 'TEST':
                window.location.replace('https://test.rail-flow.com/ords/r/sd/rq/login_desktop');
                break;
            case 'ACP':
                window.location.replace('https://acp.rail-flow.com/ords/r/sd/rq/login_desktop');
                break;
            case 'PROD':
                window.location.replace('https://apps.rail-flow.com/ords/r/sd/rq/login_desktop');
                break;
        }
           
        return;
    }

    apex.server.process("AP_INSERTAJAXERR", {
        x01: errmsg
    }, {
        success: (pData) => {
            apex.message.showErrors([{
                type: "error",
                location: ["page", "inline"],
                message: apex.lang.getMessage('DEFAULTAJAXERRORMSG'),
                unsafe: false
            }, ]);
        },
        error: (err) => {
            apex.message.showErrors([{
                type: "error",
                location: ["page", "inline"],
                message: apex.lang.getMessage('DEFAULTAJAXERRORMSG'),
                unsafe: false
            }, ]);
        }
    });
}

function f_deleteRow(ig_id, row_seq) {
    var model  = apex.region(ig_id).widget().interactiveGrid('getViews','grid').model;
    var fieldKey_seq = model.getFieldKey('SEQ');
    var deleted;

    model.getChanges().forEach(function(changedRow) {
        console.log(changedRow);
        console.log(changedRow.record[fieldKey_seq])
        console.log(changedRow.deleted)

        if (changedRow.record[fieldKey_seq] == row_seq) {
            if (changedRow.deleted == true)
                deleted = true;
            else
                deleted = false;
        }
    });

    if (deleted) 
        model.revertRecords([model.getRecord(row_seq)]);
    else
        model.deleteRecords([model.getRecord(row_seq)]);
}

function customConfirm( pMessage, pCallback, pOkLabel, pCancelLabel ){
    var l_original_messages = {"APEX.DIALOG.OK":     apex.lang.getMessage("APEX.DIALOG.OK"),
                               "APEX.DIALOG.CANCEL": apex.lang.getMessage("APEX.DIALOG.CANCEL")};

    //change the button labels messages
    apex.lang.addMessages({"APEX.DIALOG.OK":     pOkLabel});
    apex.lang.addMessages({"APEX.DIALOG.CANCEL": pCancelLabel});

    //show the confirm dialog
    apex.message.confirm(pMessage, pCallback);
    
    //the timeout is required since APEX 19.2 due to a change in the apex.message.confirm
    setTimeout(function () {
    //changes the button labels messages back to their original values
    apex.lang.addMessages({"APEX.DIALOG.OK":     l_original_messages["APEX.DIALOG.OK"]});
    apex.lang.addMessages({"APEX.DIALOG.CANCEL": l_original_messages["APEX.DIALOG.CANCEL"]});
    }, 0);
}
function f_nonDecimalSeperator(p_pageItem, p_seperator) {
    $(p_pageItem).keyup(function (event) {

        // skip for arrow keys
        if (event.which >= 37 && event.which <= 40) return;

        // format number
        $(this).val(function (index, value) {
            return value
                .replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, p_seperator);
        });
    });
}

function f_decimalSeperator(p_pageItem, p_seperator) {
    $(p_pageItem).keyup(function (event) {
        // skip for arrow keys
        if (event.which >= 37 && event.which <= 40) return;

        // format number
        $(this).val(function (index, value) {

            // format number
            $(this).val(function (index, value) {
                return value
                    .replace(/\D/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, p_seperator);
            });
            //return value;
            
            if (p_seperator == '.') {
                if (value.indexOf(",") != -1) {
                    if ((value.length - value.indexOf(",") > 3) || value.split(",").length - 1 > 1)
                        return value.slice(0, value.indexOf(",") + 3);
                }
                return value
                    .replace(/(?!\,)\D/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            } else if (p_seperator == ',') {
                if(value.indexOf(".") != -1){
                    if(value.length - value.indexOf(".") > 3)
                        return value.slice(0,value.indexOf(".")+3);
                }
                return value
                    .replace(/(?!\.)\D/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            } else if (p_seperator == ' ') {
                if (value.indexOf(",") != -1) {
                    if ((value.length - value.indexOf(",") > 3) || value.split(",").length - 1 > 1)
                        return value.slice(0, value.indexOf(",") + 3);
                }
                return value
                    .replace(/(?!\,)\D/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            }
        });
    });
}
/*
DECIMAL SEPERATORS FOR SAFARI ( It is break some feature thats why not in use for now )
function f_nonDecimalSeperator(p_pageItem, p_seperator) {
    var jQueryObject = $('#'+$(p_pageItem).attr('id'));
    var rawDOMElement = jQueryObject.get(0);
    var eventObject = $._data(rawDOMElement, 'events');
    
    if (eventObject != undefined && eventObject.keyup != undefined) {
        //keyup event exist
    }
    else{
        $(p_pageItem).keyup(function (event) {
            
            // skip for arrow keys
            if (event.which >= 37 && event.which <= 40) return;
    
            // format number
            apex.item($(p_pageItem).attr('id')).setValue(function (index, value) {
                return value
                    .replace(/\D/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, p_seperator);
            });
        });
    }
    
}

function f_decimalSeperator(p_pageItem, p_seperator) {

    var jQueryObject = $('#'+$(p_pageItem).attr('id'));
    var rawDOMElement = jQueryObject.get(0);
    var eventObject = $._data(rawDOMElement, 'events');

    //console.log('ITEM: '+'#'+$(p_pageItem).attr('id'))
    if (eventObject != undefined && eventObject.keyup != undefined) {
        //keyup event exist
    }
    else{
        $(p_pageItem).keyup(function (event) {
            // skip for arrow keys
            if (event.which >= 37 && event.which <= 40) return;
            
            
            apex.item($(p_pageItem).attr('id')).setValue(
                function (index, value) {
        
                    if (p_seperator == '.') {
                        if (value.indexOf(",") != -1) {
                            if ((value.length - value.indexOf(",") > 3) || value.split(",").length - 1 > 1)
                                return value.slice(0, value.indexOf(",") + 3);
                        }
                        return value
                            .replace(/(?!\,)\D/g, "")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                    } else {
                        if (value.indexOf(".") != -1) {
                            if (value.length - value.indexOf(".") > 3)
                                return value.slice(0, value.indexOf(".") + 3);
                        }
                        return value
                            .replace(/(?!\.)\D/g, "")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    }
                }
            )
        });
    }
    
} */

function f_downloadURI(uri, name) {
    var link = document.createElement("a");
    link.download = name;
    console.log(link.download)
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    delete link;
}

function f_getPreviewCertificate(p_docid, p_docname) {
    $s("P340_CERTIFICATEID", p_docid);
    $s("P340_CERTIFICATENAME", p_docname);
    //apex.submit("PREVIEWCERTIFICATE");
}

function f_getPreviewRequestDocument(p_docid, p_docname) {
    $s("P340_REQUESTDOCID", p_docid);
    $s("P340_REQUESTDOCNAME", p_docname);
    //apex.submit("PREVIEWREQUESTDOC");
}
function f_decimal3Seperator(p_pageItem, p_seperator) {
    $(p_pageItem).keyup(function (event) {

        // skip for arrow keys
        if (event.which >= 37 && event.which <= 40) return;

        // format number
        $(this).val(function (index, value) {

            // format number
            $(this).val(function (index, value) {
                return value
                    .replace(/\D/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, p_seperator);
            });
            //return value;

            if (p_seperator == '.') {
                if (value.indexOf(",") != -1) {
                    if ((value.length - value.indexOf(",") > 4) || value.split(",").length - 1 > 1)
                        return value.slice(0, value.indexOf(",") + 4);
                }
                return value
                    .replace(/(?!\,)\D/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            } else if (p_seperator == ',') {
                if (value.indexOf(".") != -1) {
                    if (value.length - value.indexOf(".") > 4)
                        return value.slice(0, value.indexOf(".") + 4);
                }
                return value
                    .replace(/(?!\.)\D/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
            else if (p_seperator == ' ') {
                if (value.indexOf(",") != -1) {
                    if (value.length - value.indexOf(",") > 4)
                        return value.slice(0, value.indexOf(",") + 4);
                }
                return value
                    .replace(/(?!\,)\D/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            }
        });
    });
}

function f_selectRowIG(p_staticID,p_columnName,p_columnValue){

    var widget      = apex.region(p_staticID).widget();
    var grid        = widget.interactiveGrid('getViews','grid');  
    var model       = grid.model; 
    var results     = [];

    model.forEach(function(r) {
        var record = r;
        var value = model.getValue(record,p_columnName);
        
        if(value == p_columnValue) {
          results.push(record);
        }
    })

    grid.setSelectedRecords(results);
}

function f_compareToSystemDate(p_date){
    const sysdate = moment(new Date()).format('DD/MM/YYYY hh:mm:ss');
    const formattedDate = moment(p_date,'DD-MM-YYYY hh:mm:ss').format('DD/MM/YYYY HH:mm:ss');

    if ( formattedDate > sysdate) {
        return true;
    }else{
        return false;
    }
}

function resetWarnUnsavedChanges() {
    var changedObjects = [];
  
    pageItems = apex.page.forEachPageItem;
    pageItems($("#wwvFlowForm"), function (el, name) {
      if (apex.item(name).isChanged() && !apex.item(name).element[0].classList.value.includes("js-ignoreChange")) {
        changedObjects.push(el);
      }
    }, true );
  
    //console.log("Changed Anıl", changedObjects);
  
    changedObjects.forEach((element) => {
        switch (element.type) {
            case 'hidden':
                break;
            case 'text':
                if (element.value != element.defaultValue) {
                element.defaultValue = element.value;
                }
                break;
            case 'radio':
                if (element.checked != element.defaultChecked) {
                element.defaultChecked = element.checked;
                }
                break;
            case 'checkbox':
                if (element.checked != element.defaultChecked) {
                element.defaultChecked = element.checked;
                }
                break;
            case 'select-one':
                if (element.options[element.selectedIndex] !== undefined && !element.options[element.selectedIndex].defaultSelected) {
                element.options[element.selectedIndex].defaultSelected = true;
                }
                break;
            default:
                break;
        }
    });
}

function f_fadeSuccessMessage() {
    apex.message.setThemeHooks({
        beforeShow: function(pMsgType, pElement$){
            if (pMsgType==apex.message.TYPE.SUCCESS){
                setTimeout(function() {
                    $('.t-Body-alert .t-Alert').fadeOut('slow');
                }, 1000);
            }
        }
    });
}

function f_removeParameterInURL(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
}

function f_setActiveTab(p_tab) {
    $(document).ready(() => {
        var counter = 0;
        var tabID;
        
        switch (p_tab) {
            case 'OD':
                tabID = "#SR_main_odpairsandtrafficdetails";
                break;
            default:
                return;
        }
        
        myInterval = setInterval(function () {
            counter++;
    
            if ($("#mainTabRegion").find(".t-Tabs-item.is-active").prop("id") !== undefined) {
                clearInterval(myInterval);
                apex.region("mainTabRegion").widget().aTabs("getTabs")[tabID].makeActive();
            }
            if (counter >= 10){
                clearInterval(myInterval);
            }
        }, 100);
    });
}

function f_validateDate(p_item) {
    let datePicker_input = p_item.triggeringElement,
    item = datePicker_input.parentElement,
    format = item.format;

    $(datePicker_input).keyup(function (event) {
        // skip for arrow keys
        if (event.which >= 37 && event.which <= 40) return;

        // format date
        $(this).val(function (index, value) {
            switch(value.length) {
                case 0:
                    return '';
                    break;
                case 1: // D
                    return checkRegexp(value, '[0123]');
                    break;
                case 2: // DD
                    return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})');
                    break;
                case 3: // DD-
                    return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-]');
                    break;
                case 4: // DD-M
                    return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-]([01])');
                    break;
                case 5: // DD-MM
                    return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])');
                    break;
                case 6: // DD-MM-
                    return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-]');
                    break;
                case 7: // DD-MM-Y
                    return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-][2]');
                    break;
                case 8: // DD-MM-YY
                    return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-][2][0]');
                    break;
                case 9: // DD-MM-YYY
                    return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-][2][0][2-4]');
                    break;
                case 10: // DD-MM-YYYY
                    return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-][2][0][2-4][0-9]');
                    break;
                default:
                    if (format == 'DD-MM-YYYY')
                        return value.slice(0,10);
                    else
                        switch(value.length) {
                            case 11: // DD-MM-YYYY (space at the end)
                                return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-][2][0][2-4][0-9] ');
                                break;
                            case 12: // DD-MM-YYYY H
                                return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-][2][0][2-4][0-9] ([0-2])');
                                break;
                            case 13: // DD-MM-YYYY HH
                                return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-][2][0][2-4][0-9] ([0-1]{1}[0-9]{1}|2[0-4]{1})');
                                break;
                            case 14: // DD-MM-YYYY HH:
                                return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-][2][0][2-4][0-9] ([0-1]{1}[0-9]{1}|2[0-4]{1})[:]');
                                break;
                            case 15: // DD-MM-YYYY HH:M
                                return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-][2][0][2-4][0-9] ([0-1]{1}[0-9]{1}|2[0-4]{1})[:]([0-5]{1})');
                                break;
                            case 16: // DD-MM-YYYY HH:MM
                                return checkRegexp(value, '([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-][2][0][2-4][0-9] ([0-1]{1}[0-9]{1}|2[0-4]{1})[:]([0-5]{1}[0-9]{1})');
                                break;
                            default:
                                return value.slice(0, -1);
                        }
            }
        });
    });

    function checkRegexp (value, exp) {
        let regex = new RegExp(exp);

        if (regex.test(value))
            return value;
        else 
            return value.slice(0,-1);
    };
};

function f_openShareReportModalPage(regionID,staticID,type){
    $('[data-action="share-report"]').prop( "disabled", true );
    apex.server.process("AP_GETSHAREREPORTPAGELINK",
        {
            x01: regionID, // Region ID
            x02: staticID, // Region static ID
            x03: type      // Type => Interactive Grid -> IG , Interactive Report -> IR 
        }, 
        {
            success: function (pData) {
                console.log(pData);
                if ( pData.success ) {
                    $('[data-action="share-report"]').prop( "disabled", false );
                    apex.navigation.redirect(pData.url);
                }
            },
            error:(error)=>{
                let errmsg = error?.responseText;
                $('[data-action="share-report"]').prop( "disabled", false );
                f_errorhandling(errmsg)
            }
        }
    );
}

function f_shareReport_interactiveGrid_config(config){
    let $ = apex.jQuery;
    let toolbarData = $.apex.interactiveGrid.copyDefaultToolbar();
    let toolbarGroup = toolbarData.toolbarFind("actions1");

    toolbarGroup.controls.push({
    type: "BUTTON",
    label: apex.lang.getMessage("SHAREREPORT"),
    action: "share-report",
    id: "share-report"
    });

    config.initActions = function(actions){
        actions.add({
            name: "share-report",
            action: function (){
                console.log(config);
                f_openShareReportModalPage(config.regionId,null,'IG');
            }  
        });
    }

    config.toolbarData = toolbarData;
    return config;
}

function f_duplicateRow(p_staticID,p_columnName,p_columnValue){
    let widget      = apex.region(p_staticID).widget();
    let grid        = widget.interactiveGrid('getViews','grid');  
    let model       = grid.model; 
    let results     = [];

    model.forEach(function(r) {
        let record = r;
        let value = model.getValue(record,p_columnName);
        
        if(value == p_columnValue) {
          results.push(record);
        }
    })
    
    model.copyRecords(results, null, results[0]);
}

function f_disableInActiveOptionsInLOV(p_inactive_seqs,p_class_name){
    let inactive_seq = p_inactive_seqs == "" ? [] : p_inactive_seqs.split(":");

    if(inactive_seq.length > 0) {
        document.querySelectorAll(p_class_name).forEach( opt => {    
            if (inactive_seq.includes(opt.value)){        
                opt.disabled = true;    
            }
        });
    }
}